export default __webpack_public_path__ + "static/media/Group786.838b5239.svg";